import { Grid3x3, IdCard, Trophy } from 'lucide-react';

// ИДЕИ — Igor round-3. A separate section opened from the bottom-nav «ИДЕИ»
// button (which replaced «Шоукейс»). Full-screen overlay over the seamless
// flow; the global atmosphere + bottom-nav stay visible underneath/above.
// A list of ready-made club mechanics, each attributed to a solution type via
// tags. Cards use the established translucent cool-glass panel language.
// «Простые картинки» = a brand-gradient visual block with a line icon per idea
// (real imagery can replace these later). Bento variant можно сделать позже —
// v1 is a clean readable card list.

interface IdeaCard {
  id: string;
  icon: typeof Grid3x3;
  title: string;
  description: string;
  tags: string[];
}

const IDEAS: IdeaCard[] = [
  {
    id: 'bingo',
    icon: Grid3x3,
    title: 'Русское футбольное бинго',
    description:
      'Игра для знатоков РПЛ и русского футбола. На поле — задание из конкретного сезона: несколько карточек уже заполнены, остальные нужно дополнить по памяти.',
    tags: ['квиз', 'игры', 'mini app'],
  },
  {
    id: 'passport',
    icon: IdCard,
    title: 'Сезонный паспорт болельщика',
    description:
      'Цифровой «паспорт» с 5 ячейками: первый матч, прогноз, покупка в клубном магазине, репост, привёл друга. Каждое действие — штамп в паспорт.',
    tags: ['игры', 'LTV'],
  },
  {
    id: 'league',
    icon: Trophy,
    title: 'Лига прогнозистов',
    description:
      'Сезонный лидерборд с нулевого тура: каждый тур болельщик угадывает результат, набирает очки и видит себя в таблице. К зимней паузе — церемония для топ-10.',
    tags: ['лидерборд', 'вовлечение'],
  },
];

interface IdeasViewProps {
  open: boolean;
}

export function IdeasView({ open }: IdeasViewProps) {
  if (!open) return null;

  return (
    <div className="ideas-overlay" role="dialog" aria-modal="true" aria-label="Идеи">
      <div className="ideas-overlay__scroll">
        <header className="ideas-overlay__header">
          <p className="text-rubric-mono">// ИДЕИ</p>
          <h1 className="font-display text-display leading-[1.1] tracking-[-0.02em] text-text-primary">
            Что ещё можно
            <br />
            сделать
          </h1>
          <p className="max-w-[320px] font-ui text-body leading-[1.5] text-text-muted">
            Готовые механики под клуб — с привязкой к конкретным решениям.
          </p>
        </header>

        <div className="ideas-grid">
          {IDEAS.map((idea) => {
            const Icon = idea.icon;
            return (
              <article key={idea.id} className="ideas-card">
                <div className="ideas-card__visual" aria-hidden>
                  <Icon className="h-[30px] w-[30px]" strokeWidth={1.5} />
                </div>
                <h2 className="ideas-card__title">{idea.title}</h2>
                <p className="ideas-card__desc">{idea.description}</p>
                <div className="ideas-card__tags">
                  {idea.tags.map((t) => (
                    <span key={t} className="ideas-card__tag">
                      {t}
                    </span>
                  ))}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
}
